import { type SvgProps, SvgWrapper } from '../utils';

export function CloseSmallIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967C16.8232 7.76256 16.8232 8.23732 16.5303 8.53022L8.53028 16.5302C8.23738 16.8231 7.76262 16.8231 7.46973 16.5302C7.17684 16.2373 7.17684 15.7626 7.46973 15.4697L15.4697 7.46967Z" />
      <path d="M7.46973 7.46967C7.76262 7.17678 8.23738 7.17678 8.53028 7.46967L16.5303 15.4697C16.8232 15.7626 16.8232 16.2373 16.5303 16.5302C16.2374 16.8231 15.7626 16.8231 15.4697 16.5302L7.46973 8.53022C7.17684 8.23732 7.17684 7.76256 7.46973 7.46967Z" />
    </SvgWrapper>
  );
}
